/* tslint:disable */
/* eslint-disable */
/**
 * Wire API (development)
 * The API for the Clientwire messaging service.
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: support@clientwire.net
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TwilioSettings
 */
export interface TwilioSettings {
    /**
     * The username of the Twilio account.
     * @type {string}
     * @memberof TwilioSettings
     */
    username: string;
    /**
     * The auth token of the Twilio account.
     * @type {string}
     * @memberof TwilioSettings
     */
    authToken?: string | null;
    /**
     * The account SID of the Twilio account.
     * @type {string}
     * @memberof TwilioSettings
     */
    accountSid: string;
    /**
     * The account auth token of the Twilio account.
     * @type {string}
     * @memberof TwilioSettings
     */
    accountAuthToken?: string | null;
    /**
     * The message service SID of the Twilio account.
     * @type {string}
     * @memberof TwilioSettings
     */
    messageServiceSid?: string | null;
    /**
     * The phone number of the Twilio account.
     * @type {string}
     * @memberof TwilioSettings
     */
    phoneNumber?: string | null;
}

/**
 * Check if a given object implements the TwilioSettings interface.
 */
export function instanceOfTwilioSettings(value: object): value is TwilioSettings {
    if (!('username' in value) || value['username'] === undefined) return false;
    if (!('accountSid' in value) || value['accountSid'] === undefined) return false;
    return true;
}

export function TwilioSettingsFromJSON(json: any): TwilioSettings {
    return TwilioSettingsFromJSONTyped(json, false);
}

export function TwilioSettingsFromJSONTyped(json: any, ignoreDiscriminator: boolean): TwilioSettings {
    if (json == null) {
        return json;
    }
    return {
        
        'username': json['username'],
        'authToken': json['auth_token'] == null ? undefined : json['auth_token'],
        'accountSid': json['account_sid'],
        'accountAuthToken': json['account_auth_token'] == null ? undefined : json['account_auth_token'],
        'messageServiceSid': json['message_service_sid'] == null ? undefined : json['message_service_sid'],
        'phoneNumber': json['phone_number'] == null ? undefined : json['phone_number'],
    };
}

export function TwilioSettingsToJSON(json: any): TwilioSettings {
    return TwilioSettingsToJSONTyped(json, false);
}

export function TwilioSettingsToJSONTyped(value?: TwilioSettings | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'username': value['username'],
        'auth_token': value['authToken'],
        'account_sid': value['accountSid'],
        'account_auth_token': value['accountAuthToken'],
        'message_service_sid': value['messageServiceSid'],
        'phone_number': value['phoneNumber'],
    };
}

